module.exports = __webpack_public_path__ + "img/car-repair2.149c9d7e.svg";